/* eslint-disable no-console */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
// @mui
import {
  Stack, Typography, Box, Container, Grid, Card, CardHeader, IconButton,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
// components
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { forEach, flatten, uniq } from 'lodash';
import MultiSelector from '../components/multi-selector/multiSelector';
import VideoPlayer from '../components/video-player/videoPlayer';

export default function CameraLiveStream() {
  const cameraList = useSelector((state) => state.app.cameraList);
  const { adaptorType } = window;
  const [selectedCameraList, setSelectedCameraList] = useState([]);
  const [cameraListForNvStreamer, setCameraListForNvStreamer] = useState([]);
  const [selectedTagList, setSelectedTagList] = useState([]);
  const [inputTagValue, setInputTagValue] = useState('');
  const [uniqueTags, setUniqueTags] = useState([]);
  const [cameraInRow, setCameraInRow] = useState(2);
  const [inputValue, setInputValue] = useState('');
  const location = useLocation();

  const isStreamer = location.pathname === '/streamer/streams';

  useEffect(() => {
    window.liveStreamingCameras = selectedCameraList;
    return () => {
      window.LiveStreamingCameras = null;
    };
  }, [selectedCameraList]);

  useEffect(() => {
    // if camera list refreshed, reset tag selections
    setSelectedTagList([]);
  }, [uniqueTags]);

  useEffect(() => {
    if (adaptorType === 'streamer') {
      const getUniqueTags = () => {
        try {
          let parsedTags = [];
          forEach(cameraList, (camera) => {
            const { tags } = camera;
            if (tags) {
              const locationArr = tags.split(',');
              parsedTags.push(locationArr);
            }
          });
          parsedTags = flatten(parsedTags);
          for (let i = 0; i < parsedTags.length; i += 1) {
            parsedTags[i] = parsedTags[i].trim();
          }
          parsedTags = uniq(parsedTags);
          setUniqueTags(parsedTags);
        } catch (error) {
          console.log('failed to parse tags');
        }
      };
      getUniqueTags();
    }
  }, [cameraList]);

  useEffect(() => {
    if (adaptorType === 'streamer') {
      const parsedCameraList = [];
      if (selectedTagList.length === 0) {
        setCameraListForNvStreamer(cameraList);
        return;
      }
      forEach(cameraList, (camera) => {
        const { tags } = camera;
        forEach(selectedTagList, (tag) => {
          if (tags.includes(tag)) {
            parsedCameraList.push(camera);
            return false;
          }
          return true;
        });
        console.log('camera name', camera.name);
      });
      setCameraListForNvStreamer(parsedCameraList);
    }
  }, [selectedTagList, cameraList]);

  const handleInputValue = (val) => {
    setInputValue(val);
  };

  const handleInputTagValue = (val) => {
    setInputTagValue(val);
  };

  const handleSelectedCameraListChange = (val) => {
    setSelectedCameraList(val);
  };

  const handleSelectedTagChange = (val) => {
    setSelectedTagList(val);
  };

  const handleZoomOut = () => {
    setCameraInRow((prev) => (prev < 3 ? prev + 1 : prev));
  };

  const handleZoomIn = () => {
    setCameraInRow((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const closeCamera = (camera) => {
    const temp = selectedCameraList.filter((item) => item.sensorId !== camera.sensorId);
    setSelectedCameraList(temp);
  };

  // Filter out selected cameras from the cameraList
  const availableCameras = cameraList.filter(
    (camera) => !selectedCameraList.some(selectedCamera => selectedCamera.sensorId === camera.sensorId)
  );

  // Function to filter authorized cameras
  const filterAuthorized = (cameraList) => cameraList
    .filter((camera) => camera.isAuthorized === true);

  return (
    <div
      style={{
        display:
          location.pathname === '/vst/live-streams' || location.pathname === '/mms/live-streams' || isStreamer
            ? 'inline'
            : 'none',
      }}
    >
      <Helmet>
        <title> stream </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          {isStreamer ? 'Stream' : 'Live streams'}
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title={isStreamer ? 'Stream' : 'Live streams'}
                subheader={isStreamer ? 'Stream multiple files' : 'Stream multiple live streams'}
              />
              <Box sx={{ p: 3 }}>
                {isStreamer && (
                  <Stack spacing={3} sx={{ mb: 1 }}>
                    <MultiSelector
                      id="nvstreamer-tag-selector"
                      placeholder="Type to search"
                      label="Select tags"
                      value={selectedTagList}
                      inputValue={inputTagValue}
                      onInputChange={handleInputTagValue}
                      onChange={handleSelectedTagChange}
                      getOptionLabel={(option) => `${option === '' ? 'EMPTY STRING' : option}`}
                      options={uniqueTags}
                    />
                  </Stack>
                )}
                <Stack spacing={3} sx={{ mb: 2 }}>
                  <MultiSelector
                    id="live-stream-selector-multi"
                    placeholder="Type to search"
                    label={`Select ${adaptorType === 'streamer' ? 'files' : 'cameras'}`}
                    value={selectedCameraList}
                    inputValue={inputValue}
                    onInputChange={handleInputValue}
                    onChange={handleSelectedCameraListChange}
                    getOptionLabel={(option) => {
                      if (option.remoteDeviceName && option.remoteDeviceLocation) {
                        return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
                      } if (option.remoteDeviceName) {
                        return `${option.name} at ${option.remoteDeviceName}`;
                      }
                      return option.name;

                    }}
                    options={isStreamer ? cameraListForNvStreamer : filterAuthorized(availableCameras)}
                  />
                </Stack>
                <Box
                  m={1}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  sx={{
                    display: {
                      xs: 'none', sm: 'none', md: 'none', lg: 'flex',
                    },
                  }}
                >
                  <IconButton onClick={handleZoomIn}>
                    <ZoomInIcon />
                  </IconButton>
                  <IconButton onClick={handleZoomOut}>
                    <ZoomOutIcon />
                  </IconButton>
                </Box>
              </Box>
            </Card>
          </Grid>
          {selectedCameraList.map((camera) => (
            <Grid item xs={12} sm={12} md={12 / cameraInRow} key={camera.sensorId}>
              <VideoPlayer
                camera={camera}
                cameraInRow={cameraInRow}
                // key={`${camera.sensorId + camera.host + camera.name}_vid_live`}
                page="live"
                closeCamera={closeCamera}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}
